import type { Address, Team } from '@baseball-near-you/prisma';
import { AbstractClient } from './AbstractFetchClient';

export class AddressClient extends AbstractClient {
  createAddress = this.payloadHandler<Address, { payload: Partial<Address> }>(
    'POST',
    '/'
  );

  updateAddress = this.payloadHandler<
    Address,
    { args: { id: number }; payload: Partial<Address> & Pick<Address, 'id'> }
  >('PUT', ({ id }) => `/${id}`);

  createTeamAddress = this.payloadHandler<
    Address,
    { payload: Partial<Address> & { teamId: number } }
  >('POST', () => '/team');

  getStates = this.get<{ state: string }[], never>('/states');

  getStatesAndCities = this.get<
    {
      state: string;
      cities: { city: string; citySlug: string }[];
      cityCount: number;
    }[],
    Record<string, unknown>
  >('/states/cities');

  getCities = this.get<
    Pick<Address, 'city' | 'citySlug'>[],
    { args: { stateCode: string } }
  >(({ stateCode }) => `/states/${stateCode}/cities`);

  getTeamsByState = this.get<Team[], { args: { stateCode: string } }>(
    ({ stateCode }) => `/states/${stateCode}/teams`
  );

  getTeamsByCity = this.get<
    {
      data: {
        nearbyTeams: (Team & { address: Address[] })[];
        foundAddress: Address;
      };
    },
    { args: { stateCode: string; city: string } }
  >(({ stateCode, city }) => `/states/${stateCode}/cities/${city}/teams`);
}
